import React from 'react';
import { Menu, Avatar } from 'antd';
import { LineChartOutlined, ScheduleOutlined, DotChartOutlined, BankOutlined, ContainerOutlined, CarryOutOutlined, UserOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { MenuAdmin, LOGIN } from './../../constants/menu_items';
import './styles.css';
import imageReservando from './../../images/ic_launcher.png';

const SubMenu = Menu.SubMenu;

const MainMenuAdmin = ({ onItemClick, itemSelected }) => {
    return (
        <Menu className="MainMenuCont" theme="dark" defaultSelectedKeys={[itemSelected]} mode="horizontal">
            <Menu.Item key={`/${LOGIN}`} onClick={() => {onItemClick({itemClickType: MenuAdmin.HOME})}}>
                <Avatar size={32} src={imageReservando} /> { "Administrador" }
            </Menu.Item>
            <SubMenu
                    key="sub1"
                    title={
                        <span>
                            <LineChartOutlined />
                            <span>Analíticas</span>
                        </span>
                    }>
                    <Menu.Item key={`/${LOGIN}/${MenuAdmin.ANALYTICAL_RESERVATIONS_PER_DAY}`}  onClick={() => {onItemClick({itemClickType: MenuAdmin.ANALYTICAL_RESERVATIONS_PER_DAY})}}>
                        <ScheduleOutlined />
                        <span>Reservas por día</span>
                    </Menu.Item>
                    <Menu.Item key={`/${LOGIN}/${MenuAdmin.ANALYTICAL_RESERVATIONS_RANGE}`} onClick={() => {onItemClick({itemClickType: MenuAdmin.ANALYTICAL_RESERVATIONS_RANGE})}}>
                        <DotChartOutlined />
                        <span>Reservas por rango</span>
                    </Menu.Item>
            </SubMenu>
            <SubMenu
                    key="sub2"
                    title={
                        <span>
                            <BankOutlined />
                            <span>Restaurantes</span>
                        </span>
                    }>
                    <Menu.Item key={`/${LOGIN}/${MenuAdmin.RESTAURANTS_ADMIN}`} onClick={() => {onItemClick({itemClickType: MenuAdmin.RESTAURANTS_ADMIN})}}>
                        <ContainerOutlined />
                        <span>Listado de Restaurantes</span>
                    </Menu.Item>
                    <Menu.Item key={`/${LOGIN}/${MenuAdmin.RESTAURANTS_PRIORITY_ADMIN}`} onClick={() => {onItemClick({itemClickType: MenuAdmin.RESTAURANTS_PRIORITY_ADMIN})}}>
                        <CarryOutOutlined />
                        <span>Recomendados</span>
                    </Menu.Item>
            </SubMenu>
            <Menu.Item key={`/${LOGIN}/${MenuAdmin.USERS_ADMIN}`} onClick={() => {onItemClick({itemClickType: MenuAdmin.USERS_ADMIN})}}>
                <UserOutlined />
                <span>Usuarios</span>
            </Menu.Item>
            <Menu.Item key={`/${LOGIN}/${MenuAdmin.CONFIGURATIONS_GENERAL}`} onClick={() => {onItemClick({itemClickType: MenuAdmin.CONFIGURATIONS_GENERAL})}}>
                <SettingOutlined />
                <span>Configuraciones</span>
            </Menu.Item>
            <Menu.Item key={`/${LOGIN}/${MenuAdmin.LOGOUT}`} onClick={() => {onItemClick({itemClickType: MenuAdmin.LOGOUT})}}>
                <LogoutOutlined />
                <span>Cerrar sesión</span>
            </Menu.Item>
        </Menu>
    );
};

MainMenuAdmin.propTypes = {
    
};

export default MainMenuAdmin;